<div class="row row-style-card" *ngIf="ShowCryoList">
  <a class="nav-link-hand new-button-counselling font-size-15px" title="Back To Activities" (click)="BackToIvfWorkBench()"><i class="fas fa-angle-double-left font-size-16px margin-right-4px"></i>Back To Ivf Work Bench</a>
</div>
<div class="row row-style-card" *ngIf="ShowCryoDetail">
  <a class="nav-link-hand new-button-counselling font-size-15px" title="Back To Activities" (click)="BackToList()"><i class="fas fa-angle-double-left font-size-16px margin-right-4px"></i>Back</a>
</div>
<div class="card my-profile-form " *ngIf="ShowCryoList" >
  <div class="card-header wh-header card-title-schedule-bl padding-top-6px padding-bottom-6px">
    <div class="row margin-top-3px">
      <div class="col-md-3 padding-left-0px">
        Cryo Storage
      </div>
     <div class="col-md-8 padding-right-0px">
       <div class="row">
         <div class=" offset-md-5 col-md-3 col-sm-3 padding-right padding-left-0px">
           <div class="form-group  margin-bottom-5px">
             <div class="row">
               <div class="offset-md-3 col-md-1">
                 <a (click)="DecrementDate()" title="Previous" class="nav-link-hand">
                 <i class="fas fa-angle-left margin-top-10 font-size-16px"></i>
                 </a>
               </div>
              
               

               <div class="col-md-6 col-sm-4 padding-l-0px padding-right-9px">
                 <div class="date-form">
                   <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                          name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                          (ngModelChange)="dataChanged($event)">

                   <a (click)="d.toggle()" class="nav-link-hand">
                     <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                   </a>

                 </div>



               </div>
               <div class="col-md-1 padding-left-0px">
                 <a (click)="IncrementDate()" title="Next" class="nav-link-hand">
                   <i class="fas fa-angle-right margin-top-10 font-size-16px"></i>
                 </a>
               </div>
              
             </div>

           </div>
         </div>
         <div class="col-md-3 float-right padding-right-0px">
           <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
           
         </div>
         <div class="col-md-1">
           <button type="button"
                   class="btn  btn-sm  background-primary border-all-secondary button-cryo" id="FileUpload"
                   name="upload" (click)="DisplayPatient()">
             <i class="fas fa-plus font-size-11"></i>
           </button>
         </div>
       </div>
     </div>
    </div>

  </div>
  <div class="card-body padding-top-0px">
    <!--<div class="row margin-bottom-10px margin-top-10">
    <div class="col-md-8 padding-left-30px padding-right-0px">
      <div class="row">
        <div class="col-md-3">
          <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
        
        </div>
       

      </div>
    </div>

  </div>-->
    
    <div class="row">
      <div class="col-md-12">
        <div class="table-component">
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero"
                   cols="auto,2*,*,*,*,*,*,*">

              <thead class="">
                <tr>

                  <th class="td-width-103px">
                    S.no
                  </th>
                  <!--<th class="text-align-center">Day</th>-->

                  <th class="">
                    Storage Date
                  </th>
                  <th class="">Renewal Date</th>
                  <th class="td-width-103px">Item</th>
                  <th class="td-width-159px">
                    Patients
                  </th>
                  <th class="">Age</th>
                  <th class="">
                    Contact
                  </th>





                  <th class=""></th>





                </tr>
              </thead>

              <tbody class="table-body">
                <tr *ngFor="let l of CurrentTreatmentCyclesController;let RowIndex = index ">
                  <td>{{RowIndex+1}}</td>
                  <td class="padding-right-0px td-padding-tb ">
                    AUG-29-2019


                  </td>

                  <td class="td-padding-tb">
                    AUG-31-2019
                  </td>
                  <td>Egg</td>
                  <td class="td-padding-tb">
                    <div class="row">
                      <div class="col-md-2 padding-left-10px">
                        <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" src="dummy.jpg" width="35px">
                      </div>
                      <div class="col-md-10 padding-right-0px">
                        <label class="font-size-12px margin-bottom-0px margin-top-16px margin-left-10px"> {{l.DisplayName}}</label>
                      </div>
                    </div>

                  </td>
                  <td class="td-padding-tb">
                    {{l.Age}}

                  </td>
                  <td>{{l.Telephone2}}</td>


                  <td class="td-padding-tb">

                    <a class="nav-link-hand education-navlink" title="To Cryo Storage" (click)="OpenCryo(l)">
                      <span class="badge">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <a class="nav-link-hand education-navlink" title="Edit" (click)="DisplayPatient()">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                    <div>

                    </div>
                  </td>

                </tr>
               
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</div>

<cryostoragenew   *ngIf="ShowCryoDetail" [ActorCode]='Selectedpatient.ActorCode' [CycleCode]="Selectedpatient.Code" [GradingModel]="Selectedpatient.GradingModel"></cryostoragenew>
<router-outlet></router-outlet>
